export { default as Img200 } from './processed/200/Deadline-Gallipoli.jpg';
export { default as Img400 } from './processed/400/Deadline-Gallipoli.jpg';
export { default as Imgthumb } from './processed/thumb/Deadline-Gallipoli.jpg';
export { default as ImgthumbBlurSmall } from './processed/thumbBlurSmall/Deadline-Gallipoli.jpg';
export { default as ImgthumbBlurLarge } from './processed/thumbBlurLarge/Deadline-Gallipoli.jpg';
export const ImgData = { width: 1240, height: 720, ratio: 0.5806451612903226, orientation: 'landscape' };
export const colors = {
  "Vibrant": {
    "_rgb": [
      113,
      173,
      205
    ],
    "_population": 593,
    "_hsl": [
      0.5579710144927535,
      0.47916666666666674,
      0.6235294117647059
    ]
  },
  "LightVibrant": {
    "_rgb": [
      181,
      215,
      244
    ],
    "_population": 5,
    "_hsl": [
      0.5767195767195767,
      0.7411764705882358,
      0.8333333333333334
    ]
  },
  "DarkVibrant": {
    "_rgb": [
      35,
      76,
      98
    ],
    "_population": 0
  },
  "Muted": {
    "_rgb": [
      107,
      136,
      157
    ],
    "_population": 520,
    "_hsl": [
      0.57,
      0.20325203252032525,
      0.5176470588235295
    ]
  },
  "LightMuted": {
    "_rgb": [
      172,
      200,
      219
    ],
    "_population": 2534,
    "_hsl": [
      0.5673758865248227,
      0.3949579831932772,
      0.7666666666666666
    ]
  },
  "DarkMuted": {
    "_rgb": [
      51,
      63,
      81
    ],
    "_population": 432,
    "_hsl": [
      0.6,
      0.22727272727272724,
      0.2588235294117647
    ]
  }
}


// WEBPACK FOOTER //
// ./src/content/images/Deadline-Gallipoli.js